import React from "react";
import { Text } from "@vds/core";
import { ByodContainer } from "pages/ShoppingCart/components/CartPackage/styles";

export const Header = ({count}) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
                <ByodContainer width={"auto"} height={"auto"}>
                 <div style={{display:'flex', flexDirection:'column', marginLeft: '10px', marginLeft:'30px', marginTop:'-30px'}}>
                  <Text kind="micro" style={{height:'5px'}} size="large" bold={false}>Bring your own device</Text>
                  <Text kind="body" style={{height:'5px'}} size="large" bold={true}>{count}{(count === 1) ? ' device' : ' devices'} added</Text>
                  </div>
            </ByodContainer>
            </div>
    )
}
export default Header;
